export default __webpack_public_path__ + "static/media/imgElectrolitos.b116cf58.png";